import { z } from 'zod';
import { AI_TIERS } from './job-types.js';
/**
 * `music_composer` (spec 80 section 4.12, REQ-MUS-003, S140-4): one
 * instrumental track from an editor's description, composed through the
 * license platform gateway (ElevenLabs, platform STORY-073) and stored by
 * module 30 as an audio asset of origin `ai_generated`. The run's `params`
 * carry the property, the description and the length; the audio bytes never
 * enter the run log.
 */
export const MUSIC_COMPOSER_LIMITS = {
    minPromptLength: 3,
    /** The platform accepts 2000; the guard sentence takes the rest. */
    maxPromptLength: 1500,
    /** Track length bounds in seconds (the platform allows 5 to 180). */
    minSeconds: 5,
    maxSeconds: 180,
    /** Default length: a typical reel. */
    defaultSeconds: 30,
};
/**
 * Credits of one track (platform doc `14-saas-api`, S140-4): the platform's
 * base price of task `music_composer` (provisional 10) per started 30
 * seconds, independent of the tier. Shown before the start; the platform's
 * ledger stays the billing source.
 */
export const MUSIC_COMPOSER_BASE_CREDITS = 10;
export const MUSIC_COMPOSER_BLOCK_SECONDS = 30;
export function musicComposerCredits(seconds) {
    return MUSIC_COMPOSER_BASE_CREDITS * Math.ceil(seconds / MUSIC_COMPOSER_BLOCK_SECONDS);
}
export const musicComposerInputSchema = z.object({
    property_id: z.uuid(),
    prompt: z.string().trim().min(MUSIC_COMPOSER_LIMITS.minPromptLength).max(MUSIC_COMPOSER_LIMITS.maxPromptLength),
    length_seconds: z.number().int().min(MUSIC_COMPOSER_LIMITS.minSeconds).max(MUSIC_COMPOSER_LIMITS.maxSeconds),
});
/** What the run log keeps of a composed track: never the bytes. */
export const musicComposerOutputSchema = z.object({
    media_type: z.literal('audio/mpeg'),
    length_ms: z.number().int().positive(),
    size_bytes: z.number().int().positive(),
    model: z.string().min(1).max(200),
    credits_charged: z.number().nonnegative(),
    /** The run's tier, stored on the asset as provenance (music has one price for every tier). */
    tier: z.enum(AI_TIERS),
});
//# sourceMappingURL=music-composer.js.map